import React, { useEffect, useState } from "react";
import {
  Card,
  Button,
  Table,
  Popconfirm,
  message,
  Spin,
  Typography,
  Image,
  Collapse,
} from "antd";
import axios from "axios";

const { Title } = Typography;
const { Panel } = Collapse;

const ManageTrendingItems = () => {
  const [trendingItems, setTrendingItems] = useState([]);
  const [loading, setLoading] = useState(false);

  // Fetch trending items and flatten the products
  const fetchTrendingItems = async () => {
    setLoading(true);
    const tokenString = localStorage.getItem("token");
    try {
      const response = await axios.get(
        global.config.APIURL.BaseURL + "api/TrendingItems/GetTrendingItems",
        {
          headers: {
            Authorization: "Bearer " + tokenString,
          },
        }
      );
      // Flatten the products from all categories
      const flatProducts = (response.data || []).flatMap((cat) =>
        (cat.Products || []).map((prod) => ({
          ...prod,
          Category: cat.Category,
        }))
      );
      setTrendingItems(flatProducts);
    } catch (error) {
      message.error("Failed to load trending items.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTrendingItems();
  }, []);

  // Remove trending item
  const handleRemove = async (productId) => {
    setLoading(true);
    const tokenString = localStorage.getItem("token");
    try {
      await axios.post(
        global.config.APIURL.BaseURL +
          "api/TrendingItems/RemoveTrendingItem?ProductID=" +
          productId,
        {},
        {
          headers: {
            Authorization: "Bearer " + tokenString,
          },
        }
      );
      message.success("Removed from Trending Items.");
      fetchTrendingItems();
    } catch (error) {
      message.error("Failed to remove item.");
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      title: "Image",
      dataIndex: "ImageUrl",
      key: "ImageUrl",
      render: (url) => (
        <Image
          src={url}
          alt="Product"
          width={60}
          height={60}
          style={{ objectFit: "cover", borderRadius: 4 }}
        />
      ),
    },
    {
      title: "Design No",
      dataIndex: "DesignNo",
      key: "DesignNo",
    },
    {
      title: "Product Name",
      dataIndex: "ProductName",
      key: "ProductName",
    },
    {
      title: "Category",
      dataIndex: "Category",
      key: "Category",
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Popconfirm
          title="Remove from Trending Items?"
          onConfirm={() => handleRemove(record.ProductID)}
          okText="Yes"
          cancelText="No"
        >
          <Button danger size="small">
            Remove
          </Button>
        </Popconfirm>
      ),
    },
  ];

  return (
    <Card>
      <Title level={3} style={{ marginBottom: 24 }}>
        Manage Trending Items
      </Title>
      <Spin spinning={loading}>
        <Collapse accordion>
          {Object.entries(
            trendingItems.reduce((acc, item) => {
              acc[item.Category] = acc[item.Category] || [];
              acc[item.Category].push(item);
              return acc;
            }, {})
          ).map(([category, items]) => (
            <Panel header={category} key={category}>
              <Table
                dataSource={items}
                columns={columns}
                rowKey="ProductID"
                pagination={false}
              />
            </Panel>
          ))}
        </Collapse>
      </Spin>
    </Card>
  );
};

export default ManageTrendingItems;
